/**
 * Centralized error serializer — converts unknown caught values to readable strings.
 * Prevents the "[object Object]" problem when plain objects are coerced via String().
 */
export function serializeError(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (typeof error === 'string') return error;
  if (error === null || error === undefined) return 'Unknown error';
  if (typeof error === 'object') {
    const obj = error as Record<string, unknown>;
    if (typeof obj.message === 'string') return obj.message;
    if (typeof obj.error === 'string') return obj.error;
    try { return JSON.stringify(error); } catch { return Object.prototype.toString.call(error); }
  }
  return String(error);
}
